import { render, staticRenderFns } from "./traningPlan.vue?vue&type=template&id=85f2c334&scoped=true&"
import script from "./traningPlan.vue?vue&type=script&lang=js&"
export * from "./traningPlan.vue?vue&type=script&lang=js&"
import style0 from "./traningPlan.vue?vue&type=style&index=0&id=85f2c334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f2c334",
  null
  
)

export default component.exports